var _defs, _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTestDesignInactive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n            .cls-0{fill:none;}\n            .cls-1{fill:#fff;}\n            .cls-2{fill:#efeff0;}\n            .cls-3{fill:#d2ddfa;}\n            .cls-4{fill:#b4c6fa;}\n            .cls-5{fill:#4a77f6;}\n            .cls-6{fill:#668fff;}\n            .cls-7{fill-rule:evenodd;}\n        "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-3 cls-7",
    d: "M20.84,14.13l1.93,1.29a1,1,0,0,1,.28,1.39,1,1,0,0,1-.28.27l-9.66,6.45a2,2,0,0,1-2.22,0L1.23,17.08A1,1,0,0,1,1,15.69a1,1,0,0,1,.28-.27l1.93-1.29,7.73,5.15a2,2,0,0,0,2.22,0Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M17.52,3.41,13.11.47a2,2,0,0,0-2.22,0L1.23,6.92A.93.93,0,0,0,1,7.2a1,1,0,0,0,.28,1.38l4.32,2.89a.76.76,0,0,1,.2-.2Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M13.11,15l9.66-6.45a.93.93,0,0,0,.28-.28,1,1,0,0,0-.28-1.38L17.52,3.41,5.75,11.27a.76.76,0,0,0-.2.2L10.89,15A2,2,0,0,0,13.11,15Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTestDesignInactive);
export default __webpack_public_path__ + "static/media/test-design-inactive.362f96acf0d3b74636b2c15090182b54.svg";
export { ForwardRef as ReactComponent };